<template lang="pug">
  .res.res-reschedule
    .title 改签
    //flex(:height="52")
    .content
      date-picker(@picked="onPicked" @reset="onReset")
    //flex(:height="86")
    .bottom
      primary-btn(type="rescheduleConfirm" @clicked="onConfirm" :active="picked" notice="仅有一次改签机会")
    
  
</template>
<script>
import DatePicker from '@/components/res/DatePicker'
import Flex from '@/components/Flex'
import { mapMutations, mapState, mapActions } from 'vuex'
import PrimaryBtn from '@/components/wedgits/PrimaryBtn'
import AlipayService from '@/services/AlipayService'
export default {
  name: 'ResReschedule',
  components: { PrimaryBtn, Flex, DatePicker },
  props: {},
  created() {
    console.log('reschedule created')
    this.resId = this.$route.query.resId
    this.setPending(true)
    this.GetRescheduleCalenders(this.$route.query.resId).then((res) => {
      this.setPending(false)
    })
  },
  data() {
    return {
      timeTable: [],
      picked: false,
      active: false,
      reschedule: null,
    }
  },
  computed: {
    ...mapState('app', ['user', 'calenders']),
  },
  watch: {},
  methods: {
    ...mapMutations('app', [
      'setRouterBack',
      'setScheduleTable',
      'setSchedulePicked',
      'setPending',
    ]),
    ...mapActions('app', ['GetRescheduleCalenders', 'ResReschedule']),
    onPicked(s) {
      //this.setSchedulePicked(s)
      console.log('picked!!!!', s)
      this.reschedule = s
      this.picked = true
    },
    onReset() {
      this.picked = false
    },
    onConfirm() {
      console.log(this.reschedule, this.resId)
      this.setPending(true)
      this.ResReschedule({
        resId: this.resId,
        scheduleId: this.reschedule.id,
      }).then((res) => {
        this.setPending(false)
        this.setRouterBack('/me/res')
        this.$router.replace('/me/resRescheduleProcess')
      })
    },
    onMessage(e) {
      // if (e.msg === AlipayService.Events.SCHEDULES) {
      //   this.setScheduleTable(e.schedules)
      // }
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
.res-reschedule
  .content
    margin-top: 0
  .wrapper
    width: 100%
    height: 100%
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(-100%)
</style>
